function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.35
}, React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M1971.22 60.144C1874.44 74.1819 1828.19 80.3235 1738.75 91.2906C1737.98 124.411 1738.31 139.765 1740.06 166.635C1830.93 155.229 1877.95 148.758 1977.14 134.282C1973.2 108.07 1971.99 92.9357 1971.22 60.144Z",
  fill: "#9AA7BC"
}), React.createElement("path", {
  d: "M1738.75 91.2891C1649.32 102.256 1606.24 106.972 1522.39 114.978C1521.08 148.428 1520.97 164.001 1521.41 191.419C1605.8 182.974 1649.21 178.039 1740.07 166.633C1738.32 139.764 1737.99 124.41 1738.75 91.2891Z",
  fill: "white"
}), React.createElement("path", {
  d: "M1522.39 114.98C1439.96 122.767 1400.07 125.947 1321.37 130.992C1320.27 164.771 1320.05 180.563 1319.94 208.529C1398.53 203.155 1438.54 199.756 1521.4 191.421C1520.96 164.003 1521.07 148.43 1522.39 114.98Z",
  fill: "#9AA7BC"
}), React.createElement("path", {
  d: "M1321.37 130.991C1239.93 136.146 1200.14 137.9 1120.9 139.984C1120.57 174.092 1120.35 190.104 1120.13 218.618C1198.83 216.096 1238.51 214.012 1319.83 208.529C1320.05 180.563 1320.27 164.77 1321.37 130.991Z",
  fill: "white"
}), React.createElement("path", {
  d: "M1124.3 139.982C1045.05 142.176 1006.03 142.395 927.227 141.627C927.775 176.064 927.884 192.295 927.775 221.358C1005.92 221.797 1044.72 221.249 1123.53 218.616C1123.75 190.102 1123.97 174.09 1124.3 139.982Z",
  fill: "#9AA7BC"
}), React.createElement("path", {
  d: "M930.626 141.518C851.929 140.751 812.58 139.544 732.677 135.815C734.102 170.581 734.431 187.032 734.541 216.643C814.115 220.043 853.135 220.92 931.284 221.359C931.284 192.296 931.174 176.065 930.626 141.518Z",
  fill: "white"
}), React.createElement("path", {
  d: "M737.389 136.036C656.938 132.307 616.384 129.675 532.864 122.985C534.946 158.08 535.385 174.75 535.385 204.8C618.795 211.051 659.24 213.464 739.253 216.754C739.143 187.253 738.814 170.802 737.389 136.036Z",
  fill: "#9AA7BC"
}), React.createElement("path", {
  d: "M537.906 123.313C454.386 116.623 411.75 112.566 323.407 102.915C325.709 138.338 326.037 155.228 325.38 185.826C414.38 195.038 457.017 198.877 540.427 205.128C540.427 175.078 539.989 158.518 537.906 123.313Z",
  fill: "white"
}), React.createElement("path", {
  d: "M328.777 103.574C241.092 94.0323 195.934 88.6584 101.672 76.2656C103.426 112.018 103.317 129.127 101.234 160.164C196.92 172.118 242.516 177.382 330.749 186.485C331.407 155.887 331.078 138.997 328.777 103.574Z",
  fill: "#9AA7BC"
}), React.createElement("path", {
  d: "M105.292 76.7024C59.0382 70.6705 35.4728 67.49 -12.6443 60.6904C-11.5482 96.5528 -11.9866 113.771 -15.0556 145.137C34.048 151.717 57.9421 154.788 104.854 160.601C106.936 129.564 107.046 112.455 105.292 76.7024Z",
  fill: "white"
}), React.createElement("path", {
  d: "M-12.6487 60.6915C37.551 67.7104 62.1028 71.1102 110.22 77.3614C106.713 5.85593 101.232 -34.832 80.9551 -115.55C32.9476 -122.02 8.61496 -125.42 -40.9271 -132.549C-20.2115 -51.831 -14.9504 -11.143 -12.6487 60.6915Z",
  fill: "#9AA7BC"
}), React.createElement("path", {
  d: "M1526.01 114.65C1442.05 122.656 1401.38 125.946 1321.37 130.991C1323.45 63.4332 1325.54 23.5129 1331.78 -57.4243C1414.54 -62.1401 1456.3 -65.2109 1541.68 -72.9976C1531.6 7.93964 1528.53 47.7502 1526.01 114.65Z",
  fill: "white"
}), React.createElement("path", {
  d: "M1124.3 139.983C1046.48 142.066 1008.01 142.395 930.628 141.628C929.532 72.7544 928.436 32.5051 924.6 -48.3223C1005.6 -47.2256 1045.82 -47.445 1127.04 -49.1997C1125.73 31.6278 1125.18 71.6577 1124.3 139.983Z",
  fill: "white"
}), React.createElement("path", {
  d: "M1738.75 91.2885C1649.32 102.256 1606.24 106.971 1522.39 114.977C1524.91 48.0782 1527.87 8.2677 1537.96 -72.6694C1623.34 -80.3464 1666.74 -84.8429 1756.07 -95.481C1743.58 -14.5438 1740.29 25.0473 1738.75 91.2885Z",
  fill: "#9AA7BC"
}), React.createElement("path", {
  d: "M1321.37 130.989C1241.36 136.034 1202.23 137.788 1124.3 139.982C1125.06 71.7664 1125.61 31.7365 1127.04 -49.2008C1208.26 -50.9555 1249.03 -52.6006 1331.67 -57.3164C1325.53 23.5111 1323.45 63.4314 1321.37 130.989Z",
  fill: "#9AA7BC"
}), React.createElement("path", {
  d: "M739.58 136.143C659.019 132.414 618.355 129.782 534.835 123.092C530.67 52.9029 526.395 12.4343 512.366 -68.3931C598.626 -61.3741 640.934 -58.6324 724.892 -54.5745C733.88 26.2529 736.73 66.6117 739.58 136.143Z",
  fill: "white"
}), React.createElement("path", {
  d: "M330.859 103.792C243.722 94.3601 198.893 88.9862 105.289 76.7031C101.782 5.19765 96.3016 -35.4902 76.0244 -116.208C169.409 -103.596 214.676 -98.1123 303.348 -88.3516C321.104 -7.52418 326.365 32.9444 330.859 103.792Z",
  fill: "white"
}), React.createElement("path", {
  d: "M930.626 141.52C853.244 140.752 814.663 139.655 736.075 135.927C733.225 66.3953 730.376 26.0364 721.278 -54.791C803.264 -50.8429 843.708 -49.5268 924.598 -48.4301C928.544 32.507 929.64 72.6466 930.626 141.52Z",
  fill: "#9AA7BC"
}), React.createElement("path", {
  d: "M537.903 123.314C456.466 116.843 414.925 112.895 328.774 103.573C324.171 32.7255 319.019 -7.85273 301.154 -88.6802C388.729 -79.0291 431.366 -74.9713 515.544 -68.1717C529.464 12.7654 533.738 53.1243 537.903 123.314Z",
  fill: "#9AA7BC"
}), React.createElement("path", {
  d: "M1971.23 60.1422C1874.44 74.1801 1828.19 80.3217 1738.75 91.2888C1740.28 25.0476 1743.57 -14.6533 1756.07 -95.5904C1845.4 -106.228 1891.1 -112.26 1985.58 -125.969C1972.43 -44.9225 1969.91 -5.44095 1971.23 60.1422Z",
  fill: "white"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  x: -118.416,
  y: -333.027,
  width: 2156.83,
  height: 554.387,
  fill: "white"
})));

var SvgRatingTop = function SvgRatingTop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 1920,
    height: 222,
    viewBox: "0 0 1920 222",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRatingTop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rating_top.1fcf701c.svg";
export { ForwardRef as ReactComponent };